import {
  type CreateProviderDto,
  type UpdateProviderDto,
  createProviderService,
  deleteProviderService,
  getProvidersService,
  toggleProviderActiveService,
  updateProviderService,
} from "@/services/providers.service";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";

const PROVIDERS_KEY = ["providers"] as const;

export const useProviders = () =>
  useQuery({
    queryKey: [...PROVIDERS_KEY],
    queryFn: async () => {
      const {data} = await getProvidersService();
      if (data === undefined) throw new Error("No data");
      return data;
    },
  });

export const useCreateProvider = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateProviderDto) => createProviderService(body),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: PROVIDERS_KEY});
    },
  });
};

export const useUpdateProvider = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({id, body}: {id: string; body: UpdateProviderDto}) => updateProviderService(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: PROVIDERS_KEY});
    },
  });
};

export const useToggleProviderActive = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({id, isActive}: {id: string; isActive: boolean}) => toggleProviderActiveService(id, isActive),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: PROVIDERS_KEY});
    },
  });
};

export const useDeleteProvider = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteProviderService(id),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: PROVIDERS_KEY});
    },
  });
};
